
fx.ns("shared.stage", class PrintArea extends shared.stage.Area {
    
    constructor(page, model, parentContainer, preview)
    {
        super(page, model, parentContainer, "", preview);
    }

    /***************** Actions *****************/

    get printPage()
    {
        return this.element;
    }

    get single()
    {
        return true;
    }


  /*  get orientation()
    {
        return this._orientation;
    }

    set orientation(val)
    {
        this._orientation = val;

        if (this.initialized)
            this._updateOrientation();
    }*/

    /***************** Overrides *****************/

    onReady()
    {
        super.onReady();

        this.on("click", this._increasePrint,this.increasePrintButton);
        this.on("click", this._decreasePrint,this.decreasePrintButton);
        this.on("click", this._removePrint, this.removePrintButton);

        this._updatePrintsNumber()

    }

    create()
    {
        super.create();
            
        // Bottom labels and buttons (delete / add prints)

        this.printNbText = new fx.components.Text({text: fx.text("Tirage $", this.printPage.number+1) , className:"label"});
        this.addChild(this.printNbText, {left:-7, width:"auto", height:18, top: -20});

        this.bottomButtons = new fx.components.Box("bottomButtons");

        this.removePrintButton = new fx.components.IconButton({className : "action removePrintButton", icon : fx.assets.removeIcon});
        this.removePrintButton.visibleAtStart = false;
        this.bottomButtons.addChild(this.removePrintButton, {height:40, width:40, left : 0});

        this.decreasePrintButton = new fx.components.IconButton({className : "action decreasePrintButton", icon : fx.assets.minusBtn});
        this.bottomButtons.addChild(this.decreasePrintButton, {height:40, width:40, left : 0});

        this.printNumber = new fx.components.Text({text: this.printPage.quantity, className:"label printNumber"});
        this.bottomButtons.addChild(this.printNumber, {height:40, width:40, left : 30});

        this.increasePrintButton = new fx.components.IconButton({className : "action increasePrintButton", icon : fx.assets.plusBtn});
        this.bottomButtons.addChild(this.increasePrintButton, {height:40, width:40, left : 60});

        this.addChild(this.bottomButtons, {bottom: -50, left: 70, width: 97, height: 40});

        this._manageRotation();
    }

    refresh()
    {
        super.refresh();

        this._updateButtons();
    }
    /***************** Events *****************/

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.impacts("number"))
            this._updateTexts();
        else
        if (action.impacts("quantity"))
            this._updatePrintsNumber();

    }

    onChildUpdated(action)
    {
        if (action.impacts("content")  && action.model instanceof models.CreationElementContent && action.model.isPhoto && action.tag != "update-id")
        {
            if (this.data.components.contains(action.model))
            //if (action.mode.parentModel && action.mode.parentModel.parentModel && action.mode.parentModel.parentModel.id == this.data.id)
                this._manageRotation();
        }
    }


    _updateButtons()
    {
        this.bottomButtons.css("transform", "scale(" + (1/this.scale) + ")");
        this.printNbText.css("transform", "scale(" + (1/this.scale) + ")");
        //this.bottomButtons.left( (this.model.print.pageWidth)/2-(this.bottomButtons.width() / 2 /this.scale) );
        this.bottomButtons.left( (this.width())/2-(this.bottomButtons.width() / 2 /this.scale) );
    }


    _increasePrint()
    {
        if (this.creation.canAdd)
            this.printPage.quantity++;
        else
            this.data.event("max-number-prints");
    }

    _decreasePrint()
    {
        if(this.printPage.quantity>1)
            this.printPage.quantity--;
    }

    _removePrint()
    {
        this.data.event("remove-creation", this.printPage);
    }

    _updateTexts()
    {
        if (this.printNbText)
            this.printNbText.text = fx.text("Tirage $", this.printPage.number+1);
    }

    _updatePrintsNumber()
    {
        if (this.printPage.quantity <= 1)
        {
            this.removePrintButton.show();
            this.decreasePrintButton.hide();
        }
        else
        {
            this.removePrintButton.hide();
            this.decreasePrintButton.show();
        }

        if (this.printNumber)
            this.printNumber.text = this.printPage.quantity;    
    }

    get shape()
    {
        let areaShape = "square";
        
        if (this.realWidth > this.realHeight)
            areaShape = "landscape";
        else
        if (this.realWidth < this.realHeight)
            areaShape = "portrait";

        return areaShape;
    }
    
    get orientation()
    {
        let photoComponent = this.printPage && this.printPage.photosComponents.getItemAt(0);
        if (!photoComponent)
            return "landscape";

        return (photoComponent.width == photoComponent.height) ? "square" : (photoComponent.width > photoComponent.height ? "landscape" : "portrait");
    }

    _manageRotation()
    {
        if (this.model.print.shape_option == "square")
            return;
        if(this.orientation == "portrait")
            this.viewport( {width : this.model.print.pageHeight, height : this.model.print.pageWidth} );
        else
            this.viewport( {width : this.model.print.pageWidth, height : this.model.print.pageHeight} );
    }
});